module.exports = __webpack_public_path__ + "static/images/armani-smartwatch.1430847f6076d0c27ae8106274349abd.jpg";